export default __webpack_public_path__ + "static/media/screen_wordpress_2.bc20e69f.png";